import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function classificacaoReducer(state = initialState.endereco, action){
    switch(action.type) {
        case types.CONSULTAR_CEP:
            
            return action.endereco;
        default:
            return state;
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/reduces/enderecoReducer.js
 **/